import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './styles.scss';

interface HomeSectionContentProps {
    title: string;
    seeAllPath?: string;
}

const HomeSectionContent: React.FC<HomeSectionContentProps> = ({ children, title, seeAllPath }) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));
    return (
        <section className="home-section-content-container">
            <div className="container">
                <div className="section-header">
                    <h3>{title}</h3>

                    {seeAllPath && <Link to={seeAllPath}>{strings.VIEW_ALL}</Link>}
                </div>

                {children}
            </div>
        </section>
    );
};

export { HomeSectionContent };
